import { Tabs } from '@libs/components';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  padding: 0 1.6rem;

  ${({theme}) => theme.media.laptop`
    padding: 0;
  `}
`;

export const CustomTabs = styled(Tabs)`
  height: 3.4rem;

  margin-top: 1.6rem;
  margin-bottom: 1.2rem;

  .tab-highlighter {
    height: 2.6rem;
  }
`;

export const CoinCardsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 3.2rem;
`;

export const DincamicPriceHistoryWrapper = styled.div`
  margin-top: 1.6rem;
  padding: 2rem;
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
`;

export const HistoyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Separator = styled.div`
  width: 100%;
  height: 0.05rem;
  margin: 2rem 0;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;
